import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css';
import Wrapper from "./Components/Wrapper";

ReactDOM.render(<Wrapper />, document.getElementById('root'));
